import { render, staticRenderFns } from "./WSurveyMenu.vue?vue&type=template&id=1f284d0a&"
import script from "./WSurveyMenu.vue?vue&type=script&lang=ts&"
export * from "./WSurveyMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports